import React from 'react';

export const RecordIcon2 = ({height = 64, width = 64, fill = "#FF2828",  ...props}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 38 38" fill="none">
            <circle cx="19" cy="19" r="19" fill="#EEEEEE"/>
            <circle cx="19" cy="19" r="8" fill={fill}/>
        </svg>
    )
};